module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/sienna-shiblie-1e2622648446ba52780e28c27bfd93f6.jpg";